/**
 * TeamSelectionPage.js
 * 
 * Displays all teams in the room.
 * Allows user to join one team if not already in one.
 */

import React, { useEffect, useState } from "react";
import Button from "../../../components/ui/Button"; 
import toast from "react-hot-toast";
import { joinTeam } from "../../teamHelpers";
import LoadingScreen from "../../../components/Basic/LoadingScreen";
import { sortTeams } from "../assets/teamColors";

const TeamSelectionPage = ({ user, room, setUserTeam, teams, dbCollection }) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getUserTeam = async () => {
            // --- Check if user already in any team ---
            const userTeam = teams.find(team =>
                team.members?.some(member => (member.userID || member.uid) === user.uid)
            );

            if (userTeam) {
                // ✅ User already in a team
                setUserTeam(userTeam);
                toast.success(`Welcome back to ${userTeam.name}!`);
            } else {
                // 🆕 User not in a team yet
                setLoading(false);
            }
        };

        if(teams) getUserTeam();
    }, [dbCollection, room.id, user.uid, setUserTeam, teams]);

    /**
     * Handles user joining a team
     */
    const handleJoinTeam = async (team) => {
        const success = await joinTeam(dbCollection, room.id, team.id, user);
        if (success) {
            toast.success(`Joined ${team.name}`);
            setUserTeam(team);
        } else {
            toast.error("Failed to join team");
        }
    };

    if (loading) {
        return <LoadingScreen message="Loading teams" />;
    }

    return (
        <div className="w-full max-w-4xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-6 mt-20">
            {sortTeams(teams).map((team) => (
                <div
                    key={team.id}
                    className="bg-white rounded-2xl border border-zinc-300 shadow-sm flex flex-col items-center justify-between p-6 hover:shadow-md hover:scale-[1.02] transition-all"
                >
                    <h3 className="text-xl font-bold text-zinc-800">{team.name}</h3>
                    <p className="text-sm text-zinc-600">
                        Members: {team.members.length}
                    </p>
                    <Button
                        className="mt-4 w-full bg-black text-white hover:bg-zinc-800 rounded-xl"
                        onClick={() => handleJoinTeam(team)}
                    >
                        Join Team
                    </Button>
                </div>
            ))}
        </div>
    );
};

export default TeamSelectionPage;